import React, { useState, useRef } from 'react';
import {
	Box,
	Container,
	Grid,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Typed from 'typed.js';
// import Headers from '../components/reusableComponents/Headers';
// import Carousel from '../components/reusableComponents/Carousel';
// import Footer from '../components/reusableComponents/Footer';
// import BlogsSection from './BlogsSection';
// import Nepa1 from '../assets/images/Nepal1.jpeg';
// import CarouselInterHoliday from '../components/reusableComponents/CarouselInterHoliday';
// import SearchEngineForex from '../form/SearchEngineForex';
import { useDispatch } from 'react-redux';
// import { toggleEnquiryModal } from '../reducers/UiReducer';
// import EnquiryModal from '../components/reusableComponents/EnquiryModal';
import { useHistory } from 'react-router-dom';
import HeaderHolidays from '../../components/reusableComponents/HeaderHoliday';
import HeaderHoliday from '../../components/reusableComponents/HeaderHoliday';
import Footer from './Footer';
import CarouselInterHoliday from '../../components/reusableComponents/CarouselInterHoliday';
import CarouselHoliday from '../../components/reusableComponents/CarouselHoliday';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import SearchEngineForex from '../../form/SearchEngineForex';
const data = [
	{
		fontawsClass: 'fa fa-building-o',
		title: 'Our Offices',
		desc: 'Located across the country, ready to assist in planning & booking your perfect vacation.',
		footer: 'Locate Us',
	},
	{
		fontawsClass: 'fa fa-phone',
		title: 'Call us',
		desc: "Request a quote, or just chat about your next vacation. We're always happy to help!",
		footer: '(+91) 8877773388',
	},
	{
		fontawsClass: 'fa fa-envelope',
		title: 'Write to us',
		desc: 'Be it an enquiry, feedback or a simple suggestion, write to us.',
		footer: 'info@musafirbazar.com',
	},
	{
		fontawsClass: 'fa fa-share-alt',
		title: 'Connect with us',
		desc: 'Check out reviews, podcasts, blogs and more...',
		footer: '',
	},
];
const tours = [
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/w4bPBhtX3SHBy8IFoVkzP_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'Accommodation',
		desc: 'Comfortable & convenient hotels cherry picked by our hotel management team',
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/yHA3fK6OsEC0YtsoZ4FTd_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'All meals',
		desc: "Eat to your heart's content Breakfast. Lunch. Dinner.",
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/rrm8NL4AYhsvTS7wQHt6r_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'On-tour transport',
		desc: 'Our itineraries include all rail, sea and road transport as part of the itinerary so you can enjoy tension free',
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/DGfXqw_ELotA0nLoZzlGl_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'Tour managers',
		desc: 'We have an exclusive team of 350 tour managers specialising in India and World tours',
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/smwH_pmuojWhdntRsVv6n_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'Best value itinerary',
		desc: 'Our dedicated product & destination research team spends hours curating the best value for money itineraries',
	},
	{
		image:
			'https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/bZxPCnAKkkHClpkv_d5FR_10-02-2023_132517.svg?impolicy=nowatermark',
		title: 'To and from airfare',
		desc: 'MusafirBazar tours are inclusive of airfare from many hubs within India unless you pick the joining-leaving option',
	},
];
const pacakage = [
	{
		image: 'Nepa1',
		title: 'Kolkata Travel Blog',
	},
	{
		image:
			'https://img.veenaworld.com/wp-content/uploads/2023/03/Beaches-in-Sentosa-scaled-e1678345828409.webp',
		title: 'Beaches in Sentosa',
	},
	{
		image:
			'https://img.veenaworld.com/wp-content/uploads/2023/03/Water-Parks-in-Sentosa-1-e1678339040113.png',
		title: 'Water Parks in Sentosa',
	},
	{
		image:
			'https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg',
		title: 'The Taj Mahotsav',
	},
];
const dataMauritius = [
	{
		title: 'Pearle Beach Resort & Spa',
		day: 7,
		night: 6,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/98/600x300/2984283-2984282_173380775.jpg',
		amount: '59799',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/98/600x300/2984283-2984282_173380775.jpg',
		],
		Itinerary: [
			{
				title: 'Day 1: Arrival At Mauritius',
				desc: 'Begin your Mauritius honeymoon itinerary with a relaxed day in the peaceful Mauritian environment.On landing at the Mauritius International Airport, you will be received by our local representative who will assist you with the transfer to the resort. The rest of theday would be free for you to explore the serene surroundings of the property with your adored and to get to know the idyllic beaches of Mauritius.Meals: Dinner at hotel.',
			},
			{
				title: 'Day 2: Full Day North Island Tour',
				desc: 'After breakfast, Drive to Port Louis for a visit of the capital via the Citadel (View Point) & its surrounding area and stop for a visit at Marie Reine De Paix(View Point). View the Champ de Mars race course, inaugurated in 1812; it is the oldest horse-racing club in the Southern Hemisphere, and one of the oldest in the world.Afterwards proceed to Le Caudan Waterfront, with some 170 shops. Stop at Jumbo shopping mall on the way back to hotel.Meals: Breakfast & Dinner at hotel',
			},
			{
				title: 'Day 3: Full Day Ile Aux Cerfs',
				desc: 'After breakfast, Drive to the east coast to enjoy optional (water sport activities as parasailing, undersea walk, tube ride and waterfall visit with trip around Ile Aux CerfIsland at additional cost). Afterwards as from 12.00 pm transfer by speed boat to Ile aux Cerfs. The island with the most beautiful beachand the clearest turquoise water. Free on island up to 15h30. Return back to mainland by speedboat.Carry a Beach Towel which you can collect from the hotel (on returnable basis) also carry changing clothes, Swimwear, sunscreen, cap, and do not carry passport or other valuables.Meals: Breakfast & Dinner at hotel.',
			},

			{
				title: 'Day 4: Free Day At Hotel',
				desc: 'Sneak away together to catch the sun spread its beams early in the morning at the ocean side and setthe mood for the rest of the day free for leisure. Enjoy the breakfast and gear up for a leisure breakthe Tour itinerary. Take a trip out in the glass-bottom boat at the hotel (subject to availability and weather conditions) to catch a glimpse of the tropical underwater world.Meals: Breakfast & Dinner at hotel.',
			},
			{
				title: 'Day 5: Full Day South Island Tour',
				desc: 'Visit the ship making factory. Shopping at the duty-free shops in Floreal. View the scenic town of Curepipe & its surroundings from the extinct crater of Trou aux Cerfs. Afternoon stop at Grand Bassin (Ganga Talao) sacred lake & view the stunning 108 feet statue of “Mangal Mahadev”. Visit 23 Coloured Earth, the visit to the reserve includes: the visit of green valleys, Plateaus, Hills, Lakes, Waterfalls, Rivers, Volcanic ashes, 23 Coloured Earth, endemic and Indigenous Flora and fauna and access to the many facilities of the reserve such as the Kids Garden, Cafeteria and the restaurant.Meals: Breakfast & Dinner at hotel',
			},
			{
				title: 'Day 6: Free Day At Hotel',
				desc: 'Today the day will be at leisure. Enjoy breakfast at the hotel. Explore this beautiful island on your own or head for shopping or just soak up the sun and laze around on the beach. Or explore the island or opt for any additional activities that will make the day last endlessly in the memories.Breakfast & Dinner at hotel.',
			},
			{
				title: 'Day 7: Departure From Mauritius',
				desc: 'Check out from hotel. Tour Concludes.Meals: Breakfast at hotel',
			},
		],
		flight: [
			{
				dep: 'To and Fro Flights in Economy Class (into Geneva out of Paris)',
			},
		],
		accommodation: [
			{
				roomType: 'Deluxe Garden Room',
				name: 'Pearle Beach Resort & Spa or Similar',
				meal: 'Breakfast and Dinner',
				night: '6 night(s) in Mauritius',
			},
		],
	},
	{
		title: 'Intercontinental Mauritius',
		day: 7,
		night: 6,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/77/600x300/2982415-2982414_1657266230_mauritius_b_1.jpg',
		amount: '78899',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/77/600x300/2982415-2982414_1657266230_mauritius_b_1.jpg',
		],
		Itinerary: [
			{
				title: 'Day 1: Arrival At Mauritius',
				desc: 'Begin your Mauritius honeymoon itinerary with a relaxed day in the peaceful Mauritian environment.On landing at the Mauritius International Airport, you will be received by our local representative who will assist you with the transfer to the resort. The rest of theday would be free for you to explore the serene surroundings of the property with your adored and to get to know the idyllic beaches of Mauritius.Meals: Dinner at hotel.',
			},
			{
				title: 'Day 2: Full Day North Island Tour',
				desc: 'After breakfast, Drive to Port Louis for a visit of the capital via the Citadel (View Point) & its surrounding area and stop for a visit at Marie Reine De Paix(View Point). View the Champ de Mars race course, inaugurated in 1812; it is the oldest horse-racing club in the Southern Hemisphere, and one of the oldest in the world.Afterwards proceed to Le Caudan Waterfront, with some 170 shops. Stop at Jumbo shopping mall on the way back to hotel.Meals: Breakfast & Dinner at hotel',
			},
			{
				title: 'Day 3: Full Day Ile Aux Cerfs',
				desc: 'After breakfast, Drive to the east coast to enjoy optional (water sport activities as parasailing, undersea walk, tube ride and waterfall visit with trip around Ile Aux CerfIsland at additional cost). Afterwards as from 12.00 pm transfer by speed boat to Ile aux Cerfs. The island with the most beautiful beachand the clearest turquoise water. Free on island up to 15h30. Return back to mainland by speedboat.Carry a Beach Towel which you can collect from the hotel (on returnable basis) also carry changing clothes, Swimwear, sunscreen, cap, and do not carry passport or other valuables.Meals: Breakfast & Dinner at hotel.',
			},

			{
				title: 'Day 4: Free Day At Hotel',
				desc: 'Sneak away together to catch the sun spread its beams early in the morning at the ocean side and setthe mood for the rest of the day free for leisure. Enjoy the breakfast and gear up for a leisure breakthe Tour itinerary. Take a trip out in the glass-bottom boat at the hotel (subject to availability and weather conditions) to catch a glimpse of the tropical underwater world.Meals: Breakfast & Dinner at hotel.',
			},
			{
				title: 'Day 5: Full Day South Island Tour',
				desc: 'Visit the ship making factory. Shopping at the duty-free shops in Floreal. View the scenic town of Curepipe & its surroundings from the extinct crater of Trou aux Cerfs. Afternoon stop at Grand Bassin (Ganga Talao) sacred lake & view the stunning 108 feet statue of “Mangal Mahadev”. Visit 23 Coloured Earth, the visit to the reserve includes: the visit of green valleys, Plateaus, Hills, Lakes, Waterfalls, Rivers, Volcanic ashes, 23 Coloured Earth, endemic and Indigenous Flora and fauna and access to the many facilities of the reserve such as the Kids Garden, Cafeteria and the restaurant.Meals: Breakfast & Dinner at hotel',
			},
			{
				title: 'Day 6: Free Day At Hotel',
				desc: 'Today the day will be at leisure. Enjoy breakfast at the hotel. Explore this beautiful island on your own or head for shopping or just soak up the sun and laze around on the beach. Or explore the island or opt for any additional activities that will make the day last endlessly in the memories.Breakfast & Dinner at hotel.',
			},
			{
				title: 'Day 7: Departure From Mauritius',
				desc: 'Check out from hotel. Tour Concludes.Meals: Breakfast at hotel',
			},
		],
		flight: [
			{
				dep: 'To and Fro Flights in Economy Class (into Geneva out of Paris)',
			},
		],
		accommodation: [
			{
				roomType: 'Deluxe Room',
				name: 'InterContinental Mauritius Resort Balaclava Fort, an IHG Hotel or Similar',
				meal: 'Breakfast and Dinner',
				night: '6 night(s) in Mauritius',
			},
		],
	},
	{
		title: 'Outrigger Mauritius Beach Resort',
		day: 13,
		night: 12,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/77/600x300/2982418-2982417_mauritius-image.jpg',
		amount: '118,899',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/77/600x300/2982418-2982417_mauritius-image.jpg',
		],
		Itinerary: [
			{
				title: 'Day 1: Arrival At Mauritius',
				desc: 'Begin your Mauritius honeymoon itinerary with a relaxed day in the peaceful Mauritian environment.On landing at the Mauritius International Airport, you will be received by our local representative who will assist you with the transfer to the resort. The rest of theday would be free for you to explore the serene surroundings of the property with your adored and to get to know the idyllic beaches of Mauritius.Meals: Dinner at hotel.',
			},
			{
				title: 'Day 2: Full Day North Island Tour',
				desc: 'After breakfast, Drive to Port Louis for a visit of the capital via the Citadel (View Point) & its surrounding area and stop for a visit at Marie Reine De Paix(View Point). View the Champ de Mars race course, inaugurated in 1812; it is the oldest horse-racing club in the Southern Hemisphere, and one of the oldest in the world.Afterwards proceed to Le Caudan Waterfront, with some 170 shops. Stop at Jumbo shopping mall on the way back to hotel.Meals: Breakfast & Dinner at hotel',
			},
			{
				title: 'Day 3: Full Day Ile Aux Cerfs',
				desc: 'After breakfast, Drive to the east coast to enjoy optional (water sport activities as parasailing, undersea walk, tube ride and waterfall visit with trip around Ile Aux CerfIsland at additional cost). Afterwards as from 12.00 pm transfer by speed boat to Ile aux Cerfs. The island with the most beautiful beachand the clearest turquoise water. Free on island up to 15h30. Return back to mainland by speedboat.Carry a Beach Towel which you can collect from the hotel (on returnable basis) also carry changing clothes, Swimwear, sunscreen, cap, and do not carry passport or other valuables.Meals: Breakfast & Dinner at hotel.',
			},

			{
				title: 'Day 4: Free Day At Hotel',
				desc: 'Sneak away together to catch the sun spread its beams early in the morning at the ocean side and setthe mood for the rest of the day free for leisure. Enjoy the breakfast and gear up for a leisure breakthe Tour itinerary. Take a trip out in the glass-bottom boat at the hotel (subject to availability and weather conditions) to catch a glimpse of the tropical underwater world.Meals: Breakfast & Dinner at hotel.',
			},
			{
				title: 'Day 5: Full Day South Island Tour',
				desc: 'Visit the ship making factory. Shopping at the duty-free shops in Floreal. View the scenic town of Curepipe & its surroundings from the extinct crater of Trou aux Cerfs. Afternoon stop at Grand Bassin (Ganga Talao) sacred lake & view the stunning 108 feet statue of “Mangal Mahadev”. Visit 23 Coloured Earth, the visit to the reserve includes: the visit of green valleys, Plateaus, Hills, Lakes, Waterfalls, Rivers, Volcanic ashes, 23 Coloured Earth, endemic and Indigenous Flora and fauna and access to the many facilities of the reserve such as the Kids Garden, Cafeteria and the restaurant.Meals: Breakfast & Dinner at hotel',
			},
			{
				title: 'Day 6: Free Day At Hotel',
				desc: 'Today the day will be at leisure. Enjoy breakfast at the hotel. Explore this beautiful island on your own or head for shopping or just soak up the sun and laze around on the beach. Or explore the island or opt for any additional activities that will make the day last endlessly in the memories.Breakfast & Dinner at hotel.',
			},
			{
				title: 'Day 7: Departure From Mauritius',
				desc: 'Check out from hotel. Tour Concludes.Meals: Breakfast at hotel',
			},
		],
		flight: [
			{
				dep: 'To and Fro Flights in Economy Class (into Geneva out of Paris)',
			},
		],
		accommodation: [
			{
				roomType: 'Ocean View',
				name: 'Outrigger Mauritius Beach Resort or Similar',
				meal: 'Breakfast and Dinner',
				night: '6 night(s) in Mauritius',
			},
		],
	},
];
const dataBali = [
	{
		title: 'Glimpses of Bali',
		day: 7,
		night: 6,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/90/600x300/2960135-2960134_baliwatersports.jpg',
		amount: '66099',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/90/600x300/2960135-2960134_baliwatersports.jpg',
		],
		Itinerary: [
			{
				title: 'Day 1: Arrival At Bali - Uluwatu Kecak Dance',
				desc: 'Arrival at Bali International Airport Ngurah Rai (DPS). Our representative will welcome you at the airport then transfer to your hotel.In the evening proceed for tour of Uluwatu Temple. Hanging on a cliff 100 m above the ocean, Uluwatu Temple is a great sight. In the meanwhile, you see the Kecak Dance performed by 50 dancers. Matter of fact, this dance is the only one based on vocals than instrument, dating far back into Balinese history, prior to the use of instruments.',
			},
			{
				title:
					'Day 2: Full Day Ubud Kintamani Tour With Tukad Cepung Waterfalls',
				desc: 'After breakfast proceed for Kintamani tours which will guide you around some of the most desirable and beautiful areas located in the northeast of Bali including incredible views of the Mount Batur volcano and the lakes of the area. As with most tours the eight hour tour begins at 9am at your personal hotel where air conditioned transport to the first locations that are traditional markets where cheap and beautiful gold and sliver where can be purchased and examined as well as carving of grand size and smaller examples that may make practical gifts or souvenirs. The Tukad Cepung Waterfall is one of the best among Bali waterfalls. You will be captivated by the beauty of the waterfall. A beautiful sight that you will see when you visit the waterfall, is the sun rays reflecting in the glistening water projecting a rainbow, which seems absolutely ethereal. The waterfall is well hidden between rocks and once you visit the place, you will be filled with a sense of peace of tranquility in the cool atmosphere of the Tukad Cepung Waterfall. Overnight stay at hotel.',
			},
			{
				title: 'Day 3: Water Sports Half Day + Tanah Lot With Sunset',
				desc: 'Experience Tanjung Benoa beach with the water recreational rides; banana boat, jet ski, and flying fish. You will have 1 time of Banana boat where you sit on an inflatable boat with banana shape and pulled by a speed boat moving around Tanjung Benoa costal water. 1 time ride on personal watercraft called jet ski guided by instructor, and 1 time ride of inflatable boat in flying fish-shaped, will be pulled by a speedboat with a high speed so it can lift and fly into the air. Your speedboat captain will bring you to the ocean to ride your flying fish boat.Visit a spectacular Tanah Lot Temple which stands proudly on the rock inside the ocean. Shopping time is available on this visit for any kind of Balinese handicraft products good for souvenirs and or for collection.',
			},

			{
				title: 'Day 4: North Bali With Rice Terraces And Taman Ayun Temple',
				desc: 'In the morning proceed for the Bedugul Mountain resort with its beautiful views of Lake Beratan and Ulun Danu temple. Enroute stops will also be made to visit to: Mengwi the former Royal temple of Taman Ayun and Jatiluwih the beautiful scenery of rice terraces.',
			},
			{
				title: 'Day 5 At Leisure',
				desc: 'Today you are free to explore Bali on your own. You may choose to go around the town, exploring its rich culture and heritage. You can end your day by having a dinner at a local tavern or traditional restaurant. Overnight stay at hotel.',
			},
			{
				title: 'Day 6 At Leisure',
				desc: 'Today you are free to explore Bali on your own. You may choose to go around the town, exploring its rich culture and heritage. You can end your day by having a dinner at a local tavern or traditional restaurant. Overnight stay at hotel.',
			},
			{
				title: 'Day 7: Departure From Bali',
				desc: 'Today morning check out from your hotel. You will be transferred to Bali International Airport Ngurah Rai (DPS) to catch your return flight back home.',
			},
		],
		flight: [
			{
				dep: 'Delhi (DEL)',
				deptime: '23:50',
				arr: 'Ho Chi Minh City (SGN)',
				arrtime: '06:20',
				airline: 'UK',
			},
			{
				dep: 'Ho Chi Minh City (SGN)',
				deptime: '08:15',
				arr: 'Bali (DPS)',
				arrtime: '13:05',
				airline: 'UK',
			},
			{
				dep: 'Bali (DPS)',
				deptime: '14:05 ',
				arr: 'Ho Chi Minh City (SGN)',
				arrtime: '16:55',
				airline: 'UK',
			},
			{
				dep: 'Ho Chi Minh City (SGN)',
				deptime: '19:25',
				arr: 'Delhi (DEL)',
				arrtime: '22:50',
				airline: 'UK',
			},
		],
		accommodation: [
			{
				roomType: 'Superior Room',
				name: 'Mercure Bali Legian - CHSE Certified or Similar',
				meal: 'Breakfast',
				night: '6 night(s) in Bali',
			},
		],
	},
	{
		title: 'Bali for Couples with Private Pool',
		day: 7,
		night: 6,
		image:
			'https://cdn.yourholiday.me/static/dynimg/itinerary/94/600x300/2960128-2960127_honeymoon.jpg',
		amount: '71099',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/itinerary/94/600x300/2960128-2960127_honeymoon.jpg',
		],
		Itinerary: [
			{
				title: 'Day 1: Arrival At Bali - Uluwatu Kecak Dance',
				desc: 'Arrival at Bali International Airport Ngurah Rai (DPS). Our representative will welcome you at the airport then transfer to your hotel.In the evening proceed for tour of Uluwatu Temple. Hanging on a cliff 100 m above the ocean, Uluwatu Temple is a great sight. In the meanwhile, you see the Kecak Dance performed by 50 dancers. Matter of fact, this dance is the only one based on vocals than instrument, dating far back into Balinese history, prior to the use of instruments.',
			},
			{
				title:
					'Day 2: Full Day Ubud Kintamani Tour With Tukad Cepung Waterfalls',
				desc: 'After breakfast proceed for Kintamani tours which will guide you around some of the most desirable and beautiful areas located in the northeast of Bali including incredible views of the Mount Batur volcano and the lakes of the area. As with most tours the eight hour tour begins at 9am at your personal hotel where air conditioned transport to the first locations that are traditional markets where cheap and beautiful gold and sliver where can be purchased and examined as well as carving of grand size and smaller examples that may make practical gifts or souvenirs. The Tukad Cepung Waterfall is one of the best among Bali waterfalls. You will be captivated by the beauty of the waterfall. A beautiful sight that you will see when you visit the waterfall, is the sun rays reflecting in the glistening water projecting a rainbow, which seems absolutely ethereal. The waterfall is well hidden between rocks and once you visit the place, you will be filled with a sense of peace of tranquility in the cool atmosphere of the Tukad Cepung Waterfall. Overnight stay at hotel.',
			},
			{
				title: 'Day 3: Water Sports Half Day + Tanah Lot With Sunset',
				desc: 'Experience Tanjung Benoa beach with the water recreational rides; banana boat, jet ski, and flying fish. You will have 1 time of Banana boat where you sit on an inflatable boat with banana shape and pulled by a speed boat moving around Tanjung Benoa costal water. 1 time ride on personal watercraft called jet ski guided by instructor, and 1 time ride of inflatable boat in flying fish-shaped, will be pulled by a speedboat with a high speed so it can lift and fly into the air. Your speedboat captain will bring you to the ocean to ride your flying fish boat.Visit a spectacular Tanah Lot Temple which stands proudly on the rock inside the ocean. Shopping time is available on this visit for any kind of Balinese handicraft products good for souvenirs and or for collection.',
			},

			{
				title: 'Day 4: North Bali With Rice Terraces And Taman Ayun Temple',
				desc: 'In the morning proceed for the Bedugul Mountain resort with its beautiful views of Lake Beratan and Ulun Danu temple. Enroute stops will also be made to visit to: Mengwi the former Royal temple of Taman Ayun and Jatiluwih the beautiful scenery of rice terraces.',
			},
			{
				title: 'Day 5 At Leisure',
				desc: 'Today you are free to explore Bali on your own. You may choose to go around the town, exploring its rich culture and heritage. You can end your day by having a dinner at a local tavern or traditional restaurant. Overnight stay at hotel.',
			},
			{
				title: 'Day 6 At Leisure',
				desc: 'Today you are free to explore Bali on your own. You may choose to go around the town, exploring its rich culture and heritage. You can end your day by having a dinner at a local tavern or traditional restaurant. Overnight stay at hotel.',
			},
			{
				title: 'Day 7: Departure From Bali',
				desc: 'Today morning check out from your hotel. You will be transferred to Bali International Airport Ngurah Rai (DPS) to catch your return flight back home.',
			},
		],
		flight: [
			{
				dep: 'Delhi (DEL)',
				deptime: '23:50',
				arr: 'Ho Chi Minh City (SGN)',
				arrtime: '06:20',
				airline: 'UK',
			},
			{
				dep: 'Ho Chi Minh City (SGN)',
				deptime: '08:15',
				arr: 'Bali (DPS)',
				arrtime: '13:05',
				airline: 'UK',
			},
			{
				dep: 'Bali (DPS)',
				deptime: '14:05 ',
				arr: 'Ho Chi Minh City (SGN)',
				arrtime: '16:55',
				airline: 'UK',
			},
			{
				dep: 'Ho Chi Minh City (SGN)',
				deptime: '19:25',
				arr: 'Delhi (DEL)',
				arrtime: '22:50',
				airline: 'UK',
			},
		],
		accommodation: [
			{
				roomType: 'Superior Room',
				name: 'Mercure Bali Legian - CHSE Certified or Similar',
				meal: 'Breakfast',
				night: '6 night(s) in Bali',
			},
			{
				roomType: 'One Bedroom With Private Pool',
				name: 'Lasanti Villas & Spa Seminyak or Similar',
				meal: 'Breakfast',
				night: '2 night(s) in Bali',
			},
		],
	},
	{
		title: 'Bali Flight plus Hotel and Transfers',
		day: 7,
		night: 6,
		image:
			'https://cdn.yourholiday.me/static/dynimg/destination/13/600x300/2183267-2183266_bali12.jpg',
		amount: '118,899',
		subCatimage: [
			'https://cdn.yourholiday.me/static/dynimg/destination/13/600x300/2183267-2183266_bali12.jpg',
		],
		Itinerary: [
			{
				title: 'Day 1: Arrival At Bali - Uluwatu Kecak Dance',
				desc: 'Arrival at Bali International Airport Ngurah Rai (DPS). Our representative will welcome you at the airport then transfer to your hotel.In the evening proceed for tour of Uluwatu Temple. Hanging on a cliff 100 m above the ocean, Uluwatu Temple is a great sight. In the meanwhile, you see the Kecak Dance performed by 50 dancers. Matter of fact, this dance is the only one based on vocals than instrument, dating far back into Balinese history, prior to the use of instruments.',
			},
			{
				title:
					'Day 2: Full Day Ubud Kintamani Tour With Tukad Cepung Waterfalls',
				desc: 'After breakfast proceed for Kintamani tours which will guide you around some of the most desirable and beautiful areas located in the northeast of Bali including incredible views of the Mount Batur volcano and the lakes of the area. As with most tours the eight hour tour begins at 9am at your personal hotel where air conditioned transport to the first locations that are traditional markets where cheap and beautiful gold and sliver where can be purchased and examined as well as carving of grand size and smaller examples that may make practical gifts or souvenirs. The Tukad Cepung Waterfall is one of the best among Bali waterfalls. You will be captivated by the beauty of the waterfall. A beautiful sight that you will see when you visit the waterfall, is the sun rays reflecting in the glistening water projecting a rainbow, which seems absolutely ethereal. The waterfall is well hidden between rocks and once you visit the place, you will be filled with a sense of peace of tranquility in the cool atmosphere of the Tukad Cepung Waterfall. Overnight stay at hotel.',
			},
			{
				title: 'Day 3: Water Sports Half Day + Tanah Lot With Sunset',
				desc: 'Experience Tanjung Benoa beach with the water recreational rides; banana boat, jet ski, and flying fish. You will have 1 time of Banana boat where you sit on an inflatable boat with banana shape and pulled by a speed boat moving around Tanjung Benoa costal water. 1 time ride on personal watercraft called jet ski guided by instructor, and 1 time ride of inflatable boat in flying fish-shaped, will be pulled by a speedboat with a high speed so it can lift and fly into the air. Your speedboat captain will bring you to the ocean to ride your flying fish boat.Visit a spectacular Tanah Lot Temple which stands proudly on the rock inside the ocean. Shopping time is available on this visit for any kind of Balinese handicraft products good for souvenirs and or for collection.',
			},

			{
				title: 'Day 4: North Bali With Rice Terraces And Taman Ayun Temple',
				desc: 'In the morning proceed for the Bedugul Mountain resort with its beautiful views of Lake Beratan and Ulun Danu temple. Enroute stops will also be made to visit to: Mengwi the former Royal temple of Taman Ayun and Jatiluwih the beautiful scenery of rice terraces.',
			},
			{
				title: 'Day 5 At Leisure',
				desc: 'Today you are free to explore Bali on your own. You may choose to go around the town, exploring its rich culture and heritage. You can end your day by having a dinner at a local tavern or traditional restaurant. Overnight stay at hotel.',
			},
			{
				title: 'Day 6 At Leisure',
				desc: 'Today you are free to explore Bali on your own. You may choose to go around the town, exploring its rich culture and heritage. You can end your day by having a dinner at a local tavern or traditional restaurant. Overnight stay at hotel.',
			},
			{
				title: 'Day 7: Departure From Bali',
				desc: 'Today morning check out from your hotel. You will be transferred to Bali International Airport Ngurah Rai (DPS) to catch your return flight back home.',
			},
		],
		flight: [
			{
				dep: 'Delhi (DEL)',
				deptime: '23:50',
				arr: 'Ho Chi Minh City (SGN)',
				arrtime: '06:20',
				airline: 'UK',
			},
			{
				dep: 'Ho Chi Minh City (SGN)',
				deptime: '08:15',
				arr: 'Bali (DPS)',
				arrtime: '13:05',
				airline: 'UK',
			},
			{
				dep: 'Bali (DPS)',
				deptime: '14:05 ',
				arr: 'Ho Chi Minh City (SGN)',
				arrtime: '16:55',
				airline: 'UK',
			},
			{
				dep: 'Ho Chi Minh City (SGN)',
				deptime: '19:25',
				arr: 'Delhi (DEL)',
				arrtime: '22:50',
				airline: 'UK',
			},
		],
		accommodation: [
			{
				roomType: 'Tribe Comfort Room',
				name: 'Tribe Bali Kuta Beach by Accor or Similar',
				meal: 'Breakfast',
				night: '6 night(s) in Bali',
			},
		],
	},
];
const HolidayLandingPage = () => {
	const [value, setValue] = useState('one');
	const dispatch = useDispatch();
	const history = useHistory();
	const handleChange = (val) => {
		setValue(val);
	};
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const el = React.useRef(null);
	const el2 = React.useRef(null);
	// const typed = React.useRef(null);
	React.useEffect(() => {
		// const options = {
		// 	strings: ["This Summer's Day,", 'Leave Your Footprints'],
		// 	typeSpeed: 100,
		// 	backSpeed: 100,
		// 	loop: true,
		// };

		// el.current = new Typed(el.current, options);
		const options2 = {
			strings: [
				'Launching Europe Summer 2023',
				'Dubai Winter Deal are on',
				'Best Deal for Bali with fare',
			],
			typeSpeed: 100,
			backSpeed: 100,
			loop: true,
			showCursor: false,
		};

		el2.current = new Typed(el2.current, options2);
	}, []);
	return (
		<>
			{/* <Headers /> */}
			{/* <HeaderHoliday /> */}
			<HeaderSection />
			<div
				style={{
					background:
						'linear-gradient(253.92deg, rgb(255 255 255) 0%,#721c81 40.97%, #721c81 100%)',
					height: 450,
					marginTop: matches ? 25 : 50,
				}}>
				<Container style={{ paddingTop: 20 }}>
					<Grid container>
						<Grid item xs={12} lg={6}>
							<Box>
								{matches ? (
									<>
										<h3
											// ref={el}
											style={{
												fontFamily: 'Dancing Script',
												color: 'white',
											}}>
											This Summer's Day,
										</h3>
										<h3
											ref={el2}
											style={{
												fontFamily: 'Dancing Script',
												color: 'white',
											}}></h3>
									</>
								) : (
									<>
										<h1
											// ref={el}
											style={{
												fontFamily: 'Dancing Script',
												color: 'white',
											}}>
											This Summer's Day,
										</h1>
										<h1
											ref={el2}
											style={{
												fontFamily: 'Dancing Script',
												color: 'white',
											}}></h1>
									</>
								)}
							</Box>
						</Grid>
						<Grid item xs={12} lg={6}>
							<img
								src='https://www.veenaworld.com/assets/images/home-new/womens-day/group-of-people-desktop.svg'
								style={{ width: '100%' }}
							/>
						</Grid>
					</Grid>
				</Container>
				{/* <Box>
					<h1>Flight</h1>
				</Box> */}
				<Container
					style={{
						background: 'white',
						padding: '36px',
						borderRadius: 5,
					}}>
					{/* <SearchEngineForex /> */}
					<SearchEngineForex />
					<h6
						style={{
							textAlign: 'center',
							marginTop: 20,
							fontFamily: 'Lato sans-serif',
						}}>
						Let your hair down. Set your spirit free. It’s time to have a blast.
					</h6>
					<CarouselHoliday />
					{/* <CarouselInterHoliday /> */}
				</Container>
			</div>
			{/* <Container style={{ marginTop: 200 }}>
				<h3 style={{ textAlign: 'center' }}>
					What’s on your 2023 travel bucketlist?
				</h3>
				<Grid container spacing={4} style={{ marginTop: 40, marginBottom: 40 }}>
					{[0, 1, 2, 3, 4, 5].map(() => {
						return (
							<Grid
								item
								xs={12}
								lg={2}
								style={{
									width: 'calc(16.6666666667% - 20px)',
									// margin: '0 10px',
									// borderRadius: '10px',
									position: 'relative',
									minHeight: '330px',
									color: '#fff',
									textAlign: 'center',
									cursor: 'pointer',
									background:
										'linear-gradient(180deg,rgba(0,0,0,0) 0%,#000000 100%)',
								}}>
								<img
									src='https://img.veenaworld.com/group-tours/india/jammu-and-kashmir/jklh/lhdl-ip-thb-jklh-2152022.jpg'
									style={{ width: '100%', height: '100%', borderRadius: '5px' }}
								/>
							</Grid>
						);
					})}
				</Grid>
			</Container> */}
			<Container style={{ marginTop: matches ? 565 : 250, marginBottom: 40 }}>
				<h4
					style={{
						textAlign: 'center',
						marginBottom: 20,
						fontFamily: 'Lato sans-serif',
					}}>
					All inclusive tours, Chalo Bag Bharo Nikal Pado!
				</h4>
				<Grid container spacing={4}>
					{tours.map((r) => {
						return (
							<Grid item xs={12} lg={4}>
								<Box style={{ textAlign: 'center' }}>
									<img src={r.image} />
									<h3
										style={{ color: '#721c81', fontFamily: 'Lato sans-serif' }}>
										{r.title}
									</h3>
									<span style={{ fontSize: 16, fontFamily: 'Lato sans-serif' }}>
										{r.desc}
									</span>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			{/* <Carousel /> */}

			{/* <Container style={{ marginTop: 100, marginBottom: 20 }}>
				<h3 style={{ textAlign: 'center' }}>
					Travel tips, hacks, tricks and a whole lot more...
				</h3>
				<Grid container spacing={4} style={{ marginTop: 20 }}>
					<Grid item xs={3}>
						<img
							src='https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg'
							style={{
								width: '100%',
								height: '50%',
								borderRadius: 5,
								objectFit: 'cover',
								marginBottom: 10,
							}}
						/>
						<span style={{ fontWeight: 'bold' }}>The Taj Mahostav</span>
					</Grid>
					<Grid item xs={3}>
						<img
							src='https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg'
							style={{
								width: '100%',
								height: '50%',
								borderRadius: 5,
								objectFit: 'cover',
								marginBottom: 10,
							}}
						/>
						<span style={{ fontWeight: 'bold' }}>The Taj Mahostav</span>
					</Grid>
					<Grid item xs={3}>
						<img
							src='https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg'
							style={{
								width: '100%',
								height: '50%',
								borderRadius: 5,
								objectFit: 'cover',
								marginBottom: 10,
							}}
						/>
						<span style={{ fontWeight: 'bold' }}>The Taj Mahostav</span>
					</Grid>
					<Grid item xs={3}>
						<img
							src='https://img.veenaworld.com/wp-content/uploads/2023/02/shamees-cm-WwuD8D2Xq2k-unsplash-scaled.jpg'
							style={{
								width: '100%',
								height: '50%',
								borderRadius: 5,
								objectFit: 'cover',
								marginBottom: 10,
							}}
						/>
						<span style={{ fontWeight: 'bold' }}>The Taj Mahostav</span>
					</Grid>
				</Grid>
			</Container> */}
			<Container>
				<h3 style={{ textAlign: 'center', fontFamily: 'Lato sans-serif' }}>
					Mauritius Deals with Airfare
				</h3>
				<Grid container style={{ marginTop: 20 }} spacing={2}>
					<Grid item xs={12} lg={4}></Grid>
					<Grid item xs={12} lg={5}>
						{/* <Box style={{ justifyContent: 'space-evenly', display: 'flex' }}>
							<Box
								onClick={() => handleChange('one')}
								style={{
									border: '1px solid grey',
									padding: 10,
									background: value === 'one' ? '#294992' : '',
									borderRadius: 5,
									cursor: 'pointer',
								}}>
								<span
									style={{
										color: value === 'one' ? 'white' : 'black',
										fontSize: matches ? 12 : '',
									}}>
									Explore Mightly Himalayas
								</span>
							</Box>
							<Box
								onClick={() => handleChange('two')}
								style={{
									border: '1px solid grey',
									padding: 10,
									borderRadius: 5,
									background: value === 'two' ? '#294992' : '',
									cursor: 'pointer',
								}}>
								<span
									style={{
										color: value === 'two' ? 'white' : 'black',
										fontSize: matches ? 12 : '',
									}}>
									Get Ready For Expedition
								</span>
							</Box>
						</Box> */}
					</Grid>
					<Grid item xs={12} lg={3}></Grid>
				</Grid>
				<Grid container spacing={4} style={{ marginTop: 20, marginBottom: 20 }}>
					{dataMauritius.map((i) => {
						return (
							<Grid item xs={12} lg={4}>
								<Box
									style={{
										boxShadow: '0 0 10px #00000012',
										border: '1px solid #D8D8D8',
										padding: 20,
										borderRadius: 5,
									}}>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<img
											src={i.image}
											style={{ height: '100px', borderRadius: 12 }}
										/>
										<Box style={{ textAlign: 'center' }}>
											<h5 style={{ fontFamily: 'Lato sans-serif' }}>
												{i.title}
											</h5>
											<span style={{ fontFamily: 'Lato sans-serif' }}>
												6N Mauritius
											</span>
											<br />
											<img
												src='https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/w4bPBhtX3SHBy8IFoVkzP_10-02-2023_132517.svg?impolicy=nowatermark'
												style={{ height: '30px', widht: '30px' }}
											/>
											<img
												src='https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/yHA3fK6OsEC0YtsoZ4FTd_10-02-2023_132517.svg?impolicy=nowatermark'
												style={{
													height: '30px',
													widht: '30px',
													marginLeft: 10,
												}}
											/>
											<img
												src='https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/rrm8NL4AYhsvTS7wQHt6r_10-02-2023_132517.svg?impolicy=nowatermark'
												style={{
													height: '30px',
													widht: '30px',
													marginLeft: 10,
												}}
											/>
											<img
												src='https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/bZxPCnAKkkHClpkv_d5FR_10-02-2023_132517.svg?impolicy=nowatermark'
												style={{
													height: '30px',
													widht: '30px',
													marginLeft: 10,
												}}
											/>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											// justifyContent: 'space-between',
										}}>
										<Box style={{ marginTop: 10 }}>
											{/* <h5>Leh Ladakh Manali</h5> */}
											<span style={{ fontSize: 12, color: 'grey' }}>
												Travel | 7 Days
											</span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}>
												{/* 2 Departure Cities | 2 Departure Dates */}
											</span>
										</Box>
									</Box>

									<Grid container spacing={4} style={{ marginTop: 20 }}>
										<Grid item xs={12} lg={6}>
											{/* <Box
												style={{
													background: '#DFE4F0',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
												}}>
												<span>₹ Quick Quote</span>
											</Box> */}
											<Box
												style={{
													// background: '#DFE4F0',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
													marginTop: 10,
													border: '1px solid green',
												}}>
												<span style={{ fontSize: 12 }}>Starting From</span>
											</Box>
										</Grid>
										<Grid item xs={6} style={{ textAlign: 'end' }}>
											<span style={{ color: 'green', fontSize: 12 }}>
												SUPER DEAL PRICE
											</span>
											<h2>{`₹${i.amount}`}</h2>
											<p style={{ fontSize: 12 }}>per person</p>
										</Grid>
									</Grid>
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<Box
												onClick={() =>
													history.push({ pathname: '/detail', state: i })
												}
												style={{
													background: 'yellow',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
													cursor: 'pointer',
												}}>
												<span>View Details</span>
											</Box>
										</Grid>
										<Grid item xs={6}>
											<Box
												// onClick={() => dispatch(toggleEnquiryModal(true))}
												style={{
													border: '1px solid lightgrey',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
													cursor: 'pointer',
												}}>
												<span>Enquiry Now</span>
											</Box>
										</Grid>
									</Grid>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			<Box
				style={{
					background: `url(${'https://img.veenaworld.com/vw-assets/images/homepage/World-map.svg'}) #721c81 no-repeat center`,
					// height: 500,
				}}>
				<Container style={{ paddingTop: 30, paddingBottom: 30 }}>
					<span
						style={{
							color: 'white',
							fontFamily: 'Lato sans-serif',
						}}>
						We're curating experiences that
					</span>
					<h1
						style={{
							color: 'yellow',
							fontWeight: 'bold',
							fontFamily: 'sans-serif',
						}}>
						win heart and celebrate Life
					</h1>
					<Grid container style={{ marginTop: 80 }}>
						<Grid item xs={12} lg={6}>
							<Box
								style={{
									alignItems: 'center',
									justifyContent: 'space-between',
									display: matches ? '' : 'flex',
								}}>
								<Box>
									<i
										class='fas fa-smile'
										style={{ color: 'white', fontSize: 30 }}></i>
									<h1 style={{ color: 'white' }}>6,10,291</h1>
									<span style={{ color: 'white' }}>Happy guests</span>
								</Box>
								<Box style={{ marginTop: 20 }}>
									<i
										class='fas fa-smile'
										style={{ color: 'white', fontSize: 30 }}></i>
									<h1 style={{ color: 'white' }}>43,984</h1>
									<span style={{ color: 'white' }}>Tours completed</span>
								</Box>
								<Box style={{ marginTop: 20 }}>
									<i
										class='fas fa-smile'
										style={{ color: 'white', fontSize: 30 }}></i>
									<h1 style={{ color: 'white' }}>2500+</h1>
									<span style={{ color: 'white' }}>Tour destinations</span>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12} lg={6}></Grid>
					</Grid>
				</Container>
			</Box>
			<Container style={{ marginTop: 40, marginBottom: 40 }}>
				<h3 style={{ textAlign: 'center' }}>
					Travel tips, hacks, tricks and a whole lot more...
				</h3>
				<Grid container spacing={2} style={{ marginTop: 20 }}>
					{pacakage.map((d) => {
						return (
							<Grid item xs={3}>
								<Box
									onClick={() => history.push('/blog')}
									style={{ cursor: 'pointer' }}>
									<img
										src={d.image}
										style={{ width: '100%', height: '180px', borderRadius: 10 }}
									/>
									<br />
									<Box style={{ marginTop: 10 }}>
										<span style={{ fontSize: 16 }}>{d.title}</span>
									</Box>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			<Container>
				<h3 style={{ textAlign: 'center' }}>Best Bali Deals with Airfare</h3>
				<Grid container style={{ marginTop: 20 }} spacing={2}>
					<Grid item xs={12} lg={4}></Grid>
					<Grid item xs={12} lg={5}>
						{/* <Box style={{ justifyContent: 'space-evenly', display: 'flex' }}>
							<Box
								onClick={() => handleChange('one')}
								style={{
									border: '1px solid grey',
									padding: 10,
									background: value === 'one' ? '#294992' : '',
									borderRadius: 5,
									cursor: 'pointer',
								}}>
								<span
									style={{
										color: value === 'one' ? 'white' : 'black',
										fontSize: matches ? 12 : '',
									}}>
									Explore Mightly Himalayas
								</span>
							</Box>
							<Box
								onClick={() => handleChange('two')}
								style={{
									border: '1px solid grey',
									padding: 10,
									borderRadius: 5,
									background: value === 'two' ? '#294992' : '',
									cursor: 'pointer',
								}}>
								<span
									style={{
										color: value === 'two' ? 'white' : 'black',
										fontSize: matches ? 12 : '',
									}}>
									Get Ready For Expedition
								</span>
							</Box>
						</Box> */}
					</Grid>
					<Grid item xs={12} lg={3}></Grid>
				</Grid>
				<Grid container spacing={4} style={{ marginTop: 20, marginBottom: 20 }}>
					{dataBali.map((i) => {
						return (
							<Grid item xs={12} lg={4}>
								<Box
									style={{
										boxShadow: '0 0 10px #00000012',
										border: '1px solid #D8D8D8',
										padding: 20,
										borderRadius: 5,
									}}>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<img
											src={i.image}
											style={{ height: '100px', borderRadius: 12 }}
										/>
										<Box style={{ textAlign: 'center' }}>
											<h5 style={{ fontFamily: '"Lato", sans-serif' }}>
												{i.title}
											</h5>
											<span>6N Bali</span>
											<br />
											<img
												src='https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/w4bPBhtX3SHBy8IFoVkzP_10-02-2023_132517.svg?impolicy=nowatermark'
												style={{ height: '30px', widht: '30px' }}
											/>
											<img
												src='https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/yHA3fK6OsEC0YtsoZ4FTd_10-02-2023_132517.svg?impolicy=nowatermark'
												style={{
													height: '30px',
													widht: '30px',
													marginLeft: 10,
												}}
											/>
											<img
												src='https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/rrm8NL4AYhsvTS7wQHt6r_10-02-2023_132517.svg?impolicy=nowatermark'
												style={{
													height: '30px',
													widht: '30px',
													marginLeft: 10,
												}}
											/>
											<img
												src='https://gallery.veenaworld.com/homePageCms/doYouKnow/icon/bZxPCnAKkkHClpkv_d5FR_10-02-2023_132517.svg?impolicy=nowatermark'
												style={{
													height: '30px',
													widht: '30px',
													marginLeft: 10,
												}}
											/>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											// justifyContent: 'space-between',
										}}>
										<Box style={{ marginTop: 10 }}>
											{/* <h5>Leh Ladakh Manali</h5> */}
											<span style={{ fontSize: 12, color: 'grey' }}>
												Travel | 7 Days
											</span>
											<br />
											<span style={{ fontSize: 12, color: 'grey' }}>
												{/* 2 Departure Cities | 2 Departure Dates */}
											</span>
										</Box>
									</Box>

									<Grid container spacing={4} style={{ marginTop: 20 }}>
										<Grid item xs={12} lg={6}>
											{/* <Box
												style={{
													background: '#DFE4F0',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
												}}>
												<span>₹ Quick Quote</span>
											</Box> */}
											<Box
												style={{
													// background: '#DFE4F0',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
													marginTop: 10,
													border: '1px solid green',
												}}>
												<span style={{ fontSize: 12 }}>Starting From</span>
											</Box>
										</Grid>
										<Grid item xs={6} style={{ textAlign: 'end' }}>
											<span style={{ color: 'green', fontSize: 12 }}>
												SUPER DEAL PRICE
											</span>
											<h2>{`₹${i.amount}`}</h2>
											<p style={{ fontSize: 12 }}>per person</p>
										</Grid>
									</Grid>
									<Grid container spacing={2}>
										<Grid item xs={6}>
											<Box
												onClick={() =>
													history.push({ pathname: '/detail', state: i })
												}
												style={{
													background: 'yellow',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
													cursor: 'pointer',
												}}>
												<span>View Details</span>
											</Box>
										</Grid>
										<Grid item xs={6}>
											<Box
												// onClick={() => dispatch(toggleEnquiryModal(true))}
												style={{
													border: '1px solid lightgrey',
													textAlign: 'center',
													padding: 10,
													borderRadius: 5,
													cursor: 'pointer',
												}}>
												<span>Enquiry Now</span>
											</Box>
										</Grid>
									</Grid>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			<Container style={{ marginTop: 40, marginBottom: 40 }}>
				<Grid container spacing={4}>
					<Grid item xs={12} lg={6}>
						<img
							src='https://img.veenaworld.com/og-images/india-og-1.jpg'
							style={{ width: '100%', height: '100%', borderRadius: 5 }}
						/>
					</Grid>
					<Grid item xs={12} lg={6}>
						<img
							src='https://img.veenaworld.com/og-images/india-og-1.jpg'
							style={{ width: '100%', height: '100%', borderRadius: 5 }}
						/>
					</Grid>
				</Grid>
			</Container>
			<Container style={{ marginTop: 20, marginBottom: 20 }}>
				<Grid container spacing={4}>
					{data.map((r, index) => {
						return (
							<Grid item xs={12} lg={3}>
								<Box>
									<i class={r.fontawsClass} aria-hidden='true'></i>
									<span
										style={{
											marginLeft: 10,
											fontSize: 20,
											fontFamily: '"Lato", sans-serif',
										}}>
										{r.title}
									</span>
									<br />
									<p style={{ fontSize: 12, fontFamily: '"Lato", sans-serif' }}>
										{r.desc}
									</p>
									{index === 3 ? (
										<>
											<i
												class='fa fa-facebook-square'
												aria-hidden='true'
												style={{ fontSize: 30 }}></i>
											<i
												class='fa fa-youtube-play'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-linkedin'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-instagram'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
											<i
												class='fa fa-twitter'
												aria-hidden='true'
												style={{ fontSize: 30, marginLeft: 10 }}></i>
										</>
									) : (
										<span style={{ color: 'darblue', fontWeight: 'bold' }}>
											{r.footer}
										</span>
									)}
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</Container>
			{/* <EnquiryModal /> */}
			{/* <Footer /> */}
			<Footer />
		</>
	);
};

export default HolidayLandingPage;
